// Form validation for Add Input form
import { plaintextValidator } from '../fields';

const config = {};

// add key inorder to track name from component
export default (key) => ({
  [key]: plaintextValidator({ mandatory: true })
});
